import { Link } from 'react-router';

import { describe, today } from '../../dates';
import { useLanguage } from '../../contexts/language';

import { CompletenessChip } from '../completeness-chip';
import { RecordRows } from '../record-rows';

import styles from './style.module.css';

// One day's record as a card: its completeness, then each answer, then the
// way in. A day with a record offers "Edit this record", which opens the
// check-and-save step where every answer links to its own step; a day with
// none offers "Record", which starts at the mood. Weight does not count
// towards completeness, so a day with only a weight has no entry and still
// shows the weight and offers "Edit this record". A day still to come offers
// nothing to do.
//
// Read only, as a clinician sees a patient's day: the card is titled with
// its date, medications carry their doses, and it offers nothing to do.
export function DayCard({ day, readOnly }) {
  const { text, language } = useLanguage();

  let body = <RecordRows day={ day } doses={ readOnly }/>;
  let action = <Link className={ styles.edit } to={ `/diary/record/${ day.date }/check` }>{ text.editRecord }</Link>;
  let title = text.dailyRecord;

  if (readOnly === true) {
    title = describe({ day: day.date, language });
  }

  if (day.completeness === 'NONE' && day.weightKg == null && readOnly === true) {
    body = (
      <div className={ styles.empty }>
        <p className={ styles.emptyTitle }>{ text.nothingRecorded }</p>
      </div>
    );
  }

  if (day.completeness === 'NONE' && day.weightKg == null && readOnly !== true) {
    body = (
      <div className={ styles.empty }>
        <p className={ styles.emptyTitle }>{ text.nothingRecorded }</p>

        <p className={ styles.emptyIntro }>{ text.nothingRecordedIntro }</p>
      </div>
    );
    action = <Link className={ styles.record } to={ `/diary/record/${ day.date }/mood` }>{ text.record }</Link>;
  }

  if (day.date > today()) {
    body = <p className={ styles.emptyIntro }>{ text.notYet }</p>;
    action = null;
  }

  if (readOnly === true) {
    action = null;
  }

  let footer = null;

  if (action !== null) {
    footer = <div className={ styles.footer }>{ action }</div>;
  }

  return (
    <section className={ styles.card } aria-labelledby='day-card-title'>
      <div className={ styles.header }>
        <h2 id='day-card-title' className={ styles.title }>{ title }</h2>

        <CompletenessChip completeness={ day.completeness }/>
      </div>

      { body }

      { footer }
    </section>
  );
}
